import {Avatar, Box, Checkbox, Divider, ListItemIcon, ListItemText, Menu, MenuItem, Typography} from "@mui/material";
import {Logout} from "@mui/icons-material";
import useOptimisedReports from '../hooks/useOptimisedReports';

export default function SettingsMenu({
  anchorEl,
  open,
  onClose,
  email,
  onSignOut,
}: {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  email?: string;
  onSignOut: () => Promise<void> | void;
}) {
  const [useOptimised, setUseOptimised] = useOptimisedReports();

  return (
    <Menu
      id="settings-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{ elevation: 3, sx: { mt: 1, minWidth: 230 } }}
    >
      {/* Account header */}
      <Box sx={{ px: 2, py: 1.5, display: "flex", alignItems: "center", gap: 1.5 }}>
        <Avatar sx={{ width: 32, height: 32 }}>
          {email?.[0]?.toUpperCase() ?? "U"}
        </Avatar>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
            Signed in
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              display: "block",
              maxWidth: 160,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={email}
          >
            {email ?? "user@example.com"}
          </Typography>
        </Box>
      </Box>

      <Divider />

      {/* Optimised reports toggle */}
      <MenuItem onClick={() => setUseOptimised(!useOptimised)}>
        <Checkbox
          checked={useOptimised}
          size="small"
          sx={{ p: 0, mr: 1 }}
        />
        <ListItemText primary="Use Optimised Reports" />
      </MenuItem>

      <Divider />

      {/* Sign out */}
      <MenuItem
        onClick={async () => {
          onClose();
          await onSignOut();
        }}
      >
        <ListItemIcon>
          <Logout fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Sign out" />
      </MenuItem>
    </Menu>
  );
}
